module.exports = __webpack_public_path__ + "img/Login.79d117bc.png";